import { render, staticRenderFns } from "./SendSelectedModal.vue?vue&type=template&id=f7996f18&"
import script from "./SendSelectedModal.vue?vue&type=script&lang=js&"
export * from "./SendSelectedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports